(() => {
  window.ux.eldorado.ready(() => {
    const liveChatHoursArea = document.getElementById('liveChatHoursArea');
    const liveChatHours = window.ux &&
      window.ux.eldorado &&
      window.ux.eldorado.data &&
      window.ux.eldorado.data.supportContacts &&
      window.ux.eldorado.data.supportContacts.liveChatHours;

    if (liveChatHoursArea && liveChatHours) {
      liveChatHoursArea.innerHTML = liveChatHours;
    }
  });
})();
